import React from 'react'
import { Card, Button, Col, Container, Row } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import GenericCard from '../../../components/GenericCards/GenericCards';
import { RECENT_PAYMENTS_ROUTE } from '../../../routes/types';
import { Fragment, useContext, useState } from 'react';
import RecentPaymentsModal from '../../../pages/widgets/RecentPayments/RecentPaymentsModal';
import {
  TransactionHistoryStore,
  TransactionHistoryProvider,
} from '../../../providers/recentPayments';

interface Transaction {
  currentGrossAmount: number;
  currentDeductions: number;
  YTDGrossAmount: number;
  YTDDeductions: number;
}

interface RecentPayments extends Array<Transaction> {}

function TableData() {
  const [netAmounts, setNetAmounts] = useState(false);
  const {recentPayments} = useContext(TransactionHistoryStore);
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const handleOpenModal = (recentPayments: any) => {
    setSelectedData(recentPayments);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setSelectedData(null);
    setModalOpen(false);
  };

  const numberToCurrencyString = (number: number): string => {
    // Format the number as currency
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(number);
  };

  const calculateCurrentNetAmount = (transaction: Transaction) => {
    if (netAmounts) {
      return transaction.currentGrossAmount - transaction.currentDeductions;
    } else {
      return transaction.currentGrossAmount;
    }
  };

  const calculateYTDNetAmount = (transaction: Transaction) => {
    if (netAmounts) {
      return transaction.YTDGrossAmount - transaction.YTDDeductions;
    } else {
      return transaction.YTDGrossAmount;
    }
  };

  return (
    <Row className="m-0 p-0 d-flex justify-content-between">
      <Row className={'m-0 p-0'}>
        <Col
          className={
            'p-0 d-flex justify-content-between align-items-center mb-10'
          }
        >
          <h4 className={'text-sm-20-lg-32 m-0 lh-xs'}>Recent Payments </h4>
        </Col>
      </Row>
      <GenericCard variant={'white'}>
        <Row>
          <Col className={'px-0'}>
            <Form.Check
              type="switch"
              id="payment-switch"
              label="Net Amounts"
              checked={netAmounts}
              onChange={(e) => setNetAmounts(e.target.checked)}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Row className={'d-none d-lg-flex border-bottom-dark-gray py-8'}>
              <Col className={'col-lg-4 ps-0 m-0'}>Payment Date</Col>
              <Col className={'col-lg-4 text-lg-end m-0'}>
                <span className={'text-fs-6'}>{netAmounts ? 'Monthly Net Amount' : 'Monthly Gross Amount'}</span>
              </Col>

              <Col className={'col-auto col-lg-4 text-lg-end m-0'}>
                <span className={'text-fs-6'}>{netAmounts ? 'YTD Net Amount' : 'YTD Gross Amount'}</span>
              </Col>
            </Row>
          </Col>
        </Row>
        {recentPayments.map((transaction, index) => {
          return (
            <Row
              className={
                ' px-8 py-11 px-lg-0 py-lg-8 d-flex flex-lg-row flex-wrap align-items-center border-bottom border-info'
              }
              key={index}
            >
              <Col
                className={
                  'ms-auto m-lg-0 col-12 col-lg-4 order-1 order-lg-1'
                }
              >
                <Card.Link
                  href="#"
                  className={
                    'p-0 m-0 text-fs-6 order-1 color-link text-blue nav-link-text'
                  }
                  onClick={() => handleOpenModal(transaction)}
                >
                  {transaction['paymentDate']}
                </Card.Link>
              </Col>
              <Col className={
                  ' col-8  d-lg-none order-1 order-lg-1'
                }>
                  <span className={'text-fs-6'}>{netAmounts ? 'Monthly Net Amount' : 'Monthly Gross Amount'}</span>
                  
                </Col>
              <Col
                className={
                  'col-4 text-end text-lg-end text-fs-6 m-0 col-lg-3 order-2 order-lg-2'
                }
              >
                {' '}
                {numberToCurrencyString(calculateCurrentNetAmount(transaction))}
              </Col>

              <Col className={
                  ' col-8  d-lg-none order-2 order-lg-2'
                }>
                  <span className={'text-fs-6'}>{netAmounts ? 'YTD Net Amount' : 'YTD Gross Amount'}</span>
                  
                </Col>

              <Col
                className={
                  'd-flex text-end text-lg-end d-lg-block align-items-center col-4 col-lg-4 order-5 order-lg-4 py-6 px-5 py-lg-0'
                }
              >
                <span className={'w-100 text-fs-6 m-0 '}>
                  {numberToCurrencyString(calculateYTDNetAmount(transaction))}
                </span>
              </Col>
            </Row>
          );
        })}
        {selectedData && (
            <RecentPaymentsModal
              showRecentPaymentsModal={isModalOpen}
              handleCloseRecentPaymentsModal={handleCloseModal}
              data={selectedData}
              currentStep={0}
              goToStep={function (): void {
                throw new Error('Function not implemented.');
              }}
            />
          )}
      </GenericCard>
    </Row>
  );
}
const recentPayments = () => {
  return (
    <TransactionHistoryProvider>
      <TableData />
    </TransactionHistoryProvider>
  );
};

export default recentPayments 